import type { Board } from "../board";
import type { Direction } from "../direction";
import { ALL_DIRECTIONS, directionDelta } from "../direction";
import type { Player } from "../player";
import { CannonBullet } from "../projectiles/cannonBullet";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";
import { WeaponVisual } from "../weaponVisual";

export class CannonBurst extends Weapon {
	static key = "CannonBurst";
	constructor(owner: Player, ammo: number = 5) {
		super(owner, ammo);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH;
	}

	override getWeaponVisual(): WeaponVisual {
		return WeaponVisual.CANNON;
	}

	override getMuzzleFlashCount(): number {
		return 80;
	}

	override getMuzzleFlashDirection(_direction: Direction): Direction | undefined {
		return undefined;
	}

	fire(_direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT));
		for (const dir of ALL_DIRECTIONS) {
			const spawnPos = this.owner.xy.add(directionDelta(dir));
			const bullet = new CannonBullet(spawnPos, dir);
			this.shotProjectile(board, bullet);
		}
	}

	static deserialize(data: any, owner: Player): CannonBurst {
		const gun = new CannonBurst(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
